const form = {
  formId: "new-user-form",
  formField: {
    period: {
      name: "period",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    additional: {
      name: "additional",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên tổ chức",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên tổ chức",
    },
    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    city: {
      name: "city",
      label: "[06.6] Tỉnh/thành phố:",
      type: "text",
      errorMsg: "Vui lòng chọn thành phố",
    },
    district: {
      name: "district",
      label: "[06.5] Quận/huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quận huyện",
    },
    ward: {
      name: "ward",
      label: "[06.4] Phường/xã/thị trấn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn phường",
    },
    village: {
      name: "village",
      label: "[06.3] Tổ/thôn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tổ/thôn",
    },
    road: {
      name: "road",
      label: "[06.2] Đường/phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn đường/phố",
    },
    apartment: {
      name: "apartment",
      label: "[06.1] Số nhà:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số nhà",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[07] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    taxAgentId: {
      name: "taxAgentId",
      label: "[08] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế đại lý",
    },
    taxAgentContract: {
      name: "taxAgentContract",
      label: "[09] Hợp đồng đại lý thuế: Số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số hợp đồng đại lý thuế",
    },
    daytaxAgentContract: {
      name: "daytaxAgentContract",
      label: "Ngày:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày",
    },
    //
    startingTime: {
      name: "startingTime",
      label: "[18] Thời điểm bắt đầu sử dụng đất:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập thời điểm bắt đầu sử dụng đất",
    },
    timeOfChange: {
      name: "timeOfChange",
      label: "[19] Thời điểm thay đổi diện tích đất",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập thời điểm thay đổi diện tích đất",
    },
    taxExemption: {
      name: "taxExemption",
      label: "[20] Thuế được miễn, giảm (kg)",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập thuế được miễn, giảm (kg)",
    },
    compulsoryTax: {
      name: "compulsoryTax",
      label: "[21] Thuế phải nộp tính bằng thóc ([21]=[17]-[20])",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    taxPrice: {
      name: "taxPrice",
      label: "[22] Giá thóc tính thuế (đồng/kg)",
      type: "text",
      placeholder: "",
    },
    taxMustBePaid: {
      name: "taxMustBePaid",
      label: "[23] Thuế phải nộp tính bằng tiền ([23]=[21]x[22])",
      type: "text",
      placeholder: "",
    },
    //--------------//
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
